import Chevron from "../Chevron/Chevron"
import ExclamationMarkIcon from "../ExclamationMarkIcon/ExclamationMarkIcon"
import { VIOLET_600 } from "../../styles/colors"
import { INTER } from "../../styles/fonts"
import {
  AlertBoxContainer,
  IconContainer,
  ContentContainer,
  AlertText,
  ActionContainer,
  ActionText
} from "./AlertBox.styles"
import React, { ReactNode } from "react"

type AnimationType = 'fade' | 'slide' | 'pop';

interface BaseAlertBoxProps {
  onClick?: () => void;
  actionText?: string;
  animationDuration?: number; // in seconds
  animationType?: AnimationType;
  enableIcon?: boolean;
  iconOutlineColor?: string;
  iconExclamationColor?: string;
  iconFillColor?: string;
  backgroundColor?: string;
  borderColor?: string;
  fontFamily?: string;
  textAlign?: 'left' | 'center' | 'right' | 'justify';
  style?: React.CSSProperties
  fontSize?: React.CSSProperties['fontSize']
}

interface AlertBoxWithTextProps extends BaseAlertBoxProps {
  alertText: string;
  children?: never;
}

interface AlertBoxWithChildrenProps extends BaseAlertBoxProps {
  alertText?: never;
  children: ReactNode;
}

export type AlertBoxProps = AlertBoxWithTextProps | AlertBoxWithChildrenProps;

const AlertBox = ({
  alertText,
  children,
  onClick,
  actionText,
  animationDuration = 0.3,
  animationType = 'fade',
  enableIcon = true,
  iconOutlineColor = "#F2AF01",
  iconExclamationColor = "white",
  iconFillColor = "#F2AF01",
  backgroundColor = "#FEFBE2",
  borderColor = "#F2AF01",
  fontFamily = INTER.regular,
  textAlign = 'left',
  style,
  fontSize,
}: AlertBoxProps) => {
    return (
        <AlertBoxContainer
          $animationDuration={animationDuration}
          $animationType={animationType}
          $backgroundColor={backgroundColor}
          $borderColor={borderColor}
          style={style}
        >
            {enableIcon && <IconContainer>
                <ExclamationMarkIcon
                  width={16}
                  height={16}
                  outline={iconOutlineColor}
                  exclamationColor={iconExclamationColor}
                  fill={iconFillColor}
                />
            </IconContainer>}
            <ContentContainer>
                {alertText ? (
                    <AlertText $fontFamily={fontFamily} $textAlign={textAlign} $fontSize={fontSize}>{alertText}</AlertText>
                ) : (
                    children
                )}
                {onClick && actionText && (
                <ActionContainer>
                    <ActionText onClick={onClick}>
                        {actionText}
                    </ActionText>
                    <Chevron color={VIOLET_600} strokeWidth={1} size={8} />
                </ActionContainer>
                )}
            </ContentContainer>
        </AlertBoxContainer>
    )
}

export default AlertBox
